

























































import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import { Loading, List } from "vant";
import NewsItem from "@/components/media/NewsItem.vue";
import request from "@/api/wanzhou/index";
import native from "@/common/Native";
import nopage from "@/components/404.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import { IMediaInfo, IMediaList } from "@/api/types";
import { wxChatShare } from "@/common/wechat";
import { wxChatJumpApp } from "@/common/wechatapp";
import { findNameByAppconfig } from "@/common/Utils";
import { findNameByWechatAppid } from "@/common/Utils";
@Component({
  components: {
    NewsItem,
    VanLoading: Loading,
    AppPrompt,
    vanList: List,
    nopage
  }
})
export default class SpecialPage extends Base {
  private newsList: IMediaList[] = [];
  private mediaInfo: IMediaInfo | null = null;
  public request = new request();

  private newsLoaded: boolean = false;
  public appId: string = "";
  private listLoading: boolean = false;
  private finished: boolean = false;
  wxAppId: string = "";
  isRequestLoaded: boolean = false;
  finishedText: string = "没有更多了";

  async mounted() {
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string);
    this.appId = (this.$route.query.appId as string) || "";
    this.$store.commit("SET_STATE", {
      appId: this.appId
    });
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);

    await this.getMediaDetail();
    await this.getMediaList();
  }

  onListLoad() {
    if (this.newsList.length == 0) {
      return;
    }
    this.getMediaList();
  }

  getMediaDetail() {
    this.request
      .getMediaDetail(this.infoClassifyId)
      .then(result => {
        if (result.code == 0) {
          this.mediaInfo = result.data;
          document.title = this.mediaInfo.nickname;
          this.getShareInfo(this.appId || "22");
          this.isRequestLoaded = true;

          const ua = window.navigator.userAgent.toLowerCase();
          const isWeixin = ua.indexOf("micromessenger") != -1;
          if (isWeixin) {
            const appInfo = this.$store.state.appInfo;
            const appConfig = findNameByAppconfig(
              appInfo,
              this.appId || (this.$route.query.appId as string)
            );
            const wechatConfigId = appConfig.wechatConfigId;
            const linkUrl = window.location.href;
            if (
              linkUrl &&
              appConfig.realmUrl &&
              linkUrl.indexOf(appConfig.realmUrl) != -1
            ) {
              wxChatJumpApp(
                wechatConfigId,
                this.mediaInfo.shareTitle,
                this.mediaInfo.synopsis,
                window.location.href,
                this.mediaInfo.shareImgUrl
              );
            } else {
              wxChatShare(
                this.mediaInfo.shareTitle,
                this.mediaInfo.synopsis,
                window.location.href,
                this.mediaInfo.shareImgUrl
              );
            }
          }
        } else {
          this.isRequestLoaded = true;
        }
      })
      .catch(() => {
        this.isRequestLoaded = true;
      });
  }

  getMediaList() {
    let lastId: string = "",
      sortNoValue: string = "",
      onlineTimeValue: string = "";
    if (this.newsList.length > 0) {
      let lastItem = this.newsList[this.newsList.length - 1];
      lastId = String(lastItem["id"]);
      sortNoValue = String(lastItem["sortNo"]);
      onlineTimeValue = String(lastItem["onlineTime"]);
    }
    this.newsLoaded = true;
    this.request
      .getMediaList(this.infoClassifyId, lastId, sortNoValue, onlineTimeValue)
      .then(result => {
        this.newsLoaded = false;
        if (result.code == 0) {
          if (result.data.dataList.length < 10) {
            this.finished = true;
          }
          if (!lastId && result.data.dataList.length === 0) {
            this.finishedText = "暂无数据";
          }
          if (result.data.dataList.length) {
            result.data.dataList.forEach(item => {
              if (item.images) {
                item.imgList = (item.images as string).split(";");
              } else {
                item.imgList = [];
              }
            });
            this.newsList = this.newsList.concat(result.data.dataList);
          }
        }
        this.listLoading = false;
      })
      .finally(() => {
        this.listLoading = false;
      });
  }

  newItemClick(item: IMediaList) {
    if (native.isOpenInApp()) {
      window.location.href = item.url;
    } else {
      // 端外外链新闻增加浏览量
      if (item.contextType == 3) {
        this.request.getCount(this.appId, item.id);
      }
      window.location.href = item.url;
    }
  }
}
